import {
  HTTP_BUDGETMONTH_FETCHING,
  HTTP_BUDGETMONTH_SUCCESS,
  HTTP_BUDGETMONTH_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_BUDGETMONTH_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_BUDGETMONTH_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_BUDGETMONTH_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
